import { makeStyles } from 'tss-react/mui';

const useStylesRightDrawerHeader: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  rightDrawerHeader: {
    width: 'calc(100% - 40px)',
    margin: '25px 20px',
  },
}));

export default useStylesRightDrawerHeader;
